/**
 * Pre-loaded final decision from a scrutiny result name (inspection recommendation type):
 * "Recommended" -> Approved (5), "Not Recommended" -> Not Approved (6), anything else / empty -> null.
 */
export function decisionFromScrutiny(scrutinyResult: any): number | null {
  const value = (scrutinyResult ?? '').toString().trim().toLowerCase();
  if (!value) {
    return null;
  }
  if (value.includes('not')) {
    return 6;
  }
  return value.includes('recommend') ? 5 : null;
}
